// extracted by mini-css-extract-plugin
export default {"loader":"ellipsis_loader__NTfhY","ellipsis-1":"ellipsis_ellipsis-1__XPy9A","ellipsis-2":"ellipsis_ellipsis-2__BZROD","ellipsis-3":"ellipsis_ellipsis-3__6W1IS"};